import { useForm } from "../../base";

import { getPatchForm, getPostForm, getCreatePatchForm, constants } from "..";

export function useUserForm(method, id) {
  let params = {
    storeName: constants.STORE_NAME,
    method: method,
    id: id,
  };

  if (method === "POST") {
    params.fetchMethod = getPostForm;
  } else {
    params.fetchMethod = getPatchForm;
  }

  return useForm(params);
}

export function useCreateUserForm(method, id) {
  let params = {
    storeName: constants.STORE_NAME,
    method: method,
    id: id,
  };

  params.fetchMethod = getCreatePatchForm;

  return useForm(params);
}
